import { useEffect } from 'react'

import { useCartStore } from '@/stores/cart-store/cartStore'
import { useStepStore } from '@/stores/step-store/stepStore'

export const useRoomConfigurationDependency = () => {
	const roomConfigurations = useCartStore.use.roomConfigurations()
	const removeRoom = useCartStore.use.removeRoom()
	const { selectedRooms } = useCartStore.use.roomSelection()
	const resetSteps = useStepStore.use.resetSteps()

	const length = roomConfigurations.length

	useEffect(() => {
		if (!selectedRooms.length) return

		if (length < selectedRooms.length) {
			const existingConfigIds = roomConfigurations.map((config) => config.id)
			const roomsToRemove = selectedRooms.filter(
				(room) => !existingConfigIds.includes(room.roomConfigId)
			)

			roomsToRemove.forEach((room) => {
				removeRoom(room.roomConfigId)
			})

			if (length <= 0) {
				resetSteps(['ROOM_SELECTION'])
			}
		}
	}, [length, removeRoom, resetSteps, roomConfigurations, selectedRooms])
}
